import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { normalizeLanguage, supportedLanguages, translations } from './translations';

const resources = Object.fromEntries(
  supportedLanguages.map((language) => [
    language,
    {
      translation: translations[language]
    }
  ])
);

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: normalizeLanguage(typeof navigator === 'undefined' ? undefined : navigator.language),
    fallbackLng: 'en',
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false
    },
    returnObjects: true
  });

export default i18n;
